// TicketContext.js
import { createContext, useReducer, useContext, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const TicketContext = createContext();

const initialState = {
  tickets: [],
  loading: true,
  error: '',
};

function ticketReducer(state, action) {
  switch (action.type) {
    case 'FETCH_SUCCESS':
      return { ...state, tickets: action.payload, loading: false };
    case 'FETCH_ERROR':
      return { ...state, error: action.payload, loading: false };
    case 'ADD_TICKET':
      return { ...state, tickets: [action.payload, ...state.tickets] };
    case 'UPDATE_TICKET':
      return { ...state, tickets: state.tickets.map((ticket) =>ticket._id === action.payload._id ? action.payload : ticket) };
    case 'DELETE_TICKET':
      return { ...state, tickets: state.tickets.filter((ticket) => ticket._id !== action.payload) };
    default:
      return state;
  }
}

export const TicketProvider = ({ children }) => {
  const { token } = useAuth();
  const [state, dispatch] = useReducer(ticketReducer, initialState);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/tickets`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch({ type: 'FETCH_SUCCESS', payload: res.data });
      } catch (err) {
        dispatch({ type: 'FETCH_ERROR', payload: 'Failed to fetch tickets' });
      }
    };
    if (token) fetchTickets();
  }, [token]);

  return (
    <TicketContext.Provider value={{ ...state, dispatch }}>
      {children}
    </TicketContext.Provider>
  );
};

export const useTicketsContext = () => {
  const context = useContext(TicketContext);
  if (!context) {
    throw new Error('useTicketsContext must be used within a TicketProvider');
  }
  return context;
};
